import{reNum as e}from"../../parser/constants.min.mjs";const r=new RegExp("(".concat(e,")"),"gi"),c=e=>e.replace(r," $1 ").replace(/,/gi," ").replace(/\s+/gi," ");export{c as cleanupSvgAttribute};
//# sourceMappingURL=cleanupSvgAttribute.min.mjs.map
